var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_699_5101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 134
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 134,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_699_5101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9615 64.3201L87.9456 47.7455L27.1191 16.2236V64.3041L66.0589 85.106L80.2884 78.8367L37.4403 56.1046L37.4722 37.887L87.9615 64.3201Z",
    fill: "url(#paint0_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7607 44.8421V50.5052L37.3926 56.2321L37.4883 37.6636L50.7607 44.8421Z",
    fill: "url(#paint1_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8095 91.822L80.2895 78.8368L37.4414 56.2163L50.6819 50.5054L105.765 79.2835L50.9212 103.212L50.8095 91.822Z",
    fill: "url(#paint2_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4886 87.9773L50.6493 82.2982L50.9365 103.196L105.765 79.2832V97.118L37.377 127.077L37.4886 87.9773Z",
    fill: "url(#paint3_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1191 82.5857L37.4403 87.9776L37.3765 127.013L27.1191 121.86V82.5857Z",
    fill: "url(#paint4_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1522 76.7791L50.6489 82.2986L37.4403 87.9776L27.1191 82.5857L40.1522 76.7791Z",
    fill: "url(#paint5_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.765 56.5993L105.702 39.9131L87.9785 47.7457V64.3362L105.765 56.5993Z",
    fill: "url(#paint6_linear_699_5101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1191 16.2237L45.0337 7.97632L105.732 39.8811L87.9775 47.7456L27.1191 16.2237Z",
    fill: "url(#paint7_linear_699_5101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_699_5101",
    x1: 11.9006,
    y1: 50.6648,
    x2: 119.372,
    y2: 50.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_699_5101",
    x1: 44.0766,
    y1: 62.8524,
    x2: 44.0766,
    y2: 21.2167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_699_5101",
    x1: 37.4414,
    y1: 76.8587,
    x2: 146.891,
    y2: 76.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E4D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A4A6B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3F57C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_699_5101",
    x1: 15.0596,
    y1: 103.18,
    x2: 155.01,
    y2: 103.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#62A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1032D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_699_5101",
    x1: 628.741,
    y1: 3244.93,
    x2: 797.782,
    y2: 3247.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_699_5101",
    x1: 24.5987,
    y1: 82.3783,
    x2: 72.5834,
    y2: 82.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_699_5101",
    x1: 70.9573,
    y1: 52.5952,
    x2: 189.069,
    y2: 50.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_699_5101",
    x1: 27.1191,
    y1: 27.8689,
    x2: 173.642,
    y2: 27.8689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E6D5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A7D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#43D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#37B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2B8CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#216B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#184E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#10353F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0A2228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#061316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#010202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubWalletLogo);
export default __webpack_public_path__ + "static/media/SubWalletLogo.637b860fce4059c3a3b6b7c876a13601.svg";
export { ForwardRef as ReactComponent };